import { z } from 'zod';
import { uuidSchema } from './common';

/** Настройка действует на следующие назначения статуса, без массового переноса истории. */
export const rotationSettingsSchema = z.object({
  enabled: z.boolean(),
  statusIds: z.array(uuidSchema).max(200).refine((ids) => new Set(ids).size === ids.length, 'Статусы не должны повторяться'),
}).strict();

export type RotationSettings = z.infer<typeof rotationSettingsSchema>;

export const DEFAULT_ROTATION_STATUS_CODES = ['in_car', 'office', 'registered', 'remote'] as const;

/** «Оформился» исторически добавляли вручную, поэтому у него нет общего кода. */
export function isDefaultRotationStatus(status: { code: string; name: string }): boolean {
  return (DEFAULT_ROTATION_STATUS_CODES as readonly string[]).includes(status.code)
    || /^оформил(?:ся|ась)(?:\s*\(\s*-?ась\s*\))?$/iu.test(status.name.trim());
}
